import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/view/Home';
import Account from '@/view/Account';
import Search from '@/view/Search';
import AddCustomCoin from '@/view/AddCustomCoin';
import AddExistingCoin from '@/view/AddExistingCoin';
import Coin from '@/view/Coin';
import EditCoin from '@/view/EditCoin';
import FourOhFour from '@/view/FourOhFour';

Vue.use(Router);

export default new Router({
  mode: 'history',
  hashbang: false,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
    },
    {
      path: '/add',
      name: 'AddCustom',
      component: AddCustomCoin,
    },
    {
      path: '/add/:coinId',
      name: 'AddExisting',
      component: AddExistingCoin,
    },
    {
      path: '/coin/:code',
      name: 'Coin',
      component: Coin,
    },
    {
      path: '/edit/:purchaseId',
      name: 'Edit',
      component: EditCoin,
    },
    {
      path: '*',
      name: 'FourOhFour',
      component: FourOhFour,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js